export default __webpack_public_path__ + "static/media/explore-btn.f067b84c.svg";